import React, {useEffect} from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom';
import Button from '@mui/joy/Button';
import {useAuth} from "../auth/useAuth";
import {getAuthMetaDataApi, steamLoginApi} from "./loginAPI";
import {SteamLoginRequest} from "../../models/steam";
import {NotificationService} from "../../common/notification";
import {AuthMetaData} from "../../models/auth";

export function SteamLoginButton(props: {
    disabled: boolean,
    setLoggingIn: (value:boolean) => void
}) {
    const {disabled, setLoggingIn} = props;
    const navigate = useNavigate();
    const auth = useAuth();

    const [searchParams, setSearchParams] = useSearchParams();

    const login=async (request: SteamLoginRequest) => {
        try {
            let result = await steamLoginApi(request);
            if (result.result) {
                result = auth.externalUserLogin(result.value);
                if (result.result) {
                    navigate('/app/users');
                    return;
                } else {
                    NotificationService.alertError(result.value)
                }
            } else {
                NotificationService.alertError(result.value)
            }
            searchParams.delete('openid.ns');
            searchParams.delete('openid.mode');
            searchParams.delete('openid.op_endpoint');
            searchParams.delete('openid.claimed_id');
            searchParams.delete('openid.identity');
            searchParams.delete('openid.return_to');
            searchParams.delete('openid.response_nonce');
            searchParams.delete('openid.assoc_handle');
            searchParams.delete('openid.signed');
            searchParams.delete('openid.sig');
            setSearchParams(searchParams);

        } finally {
            setLoggingIn(false);
        }
    }

    useEffect(() => {
        if (searchParams.has('openid.ns')) {
            setLoggingIn(true);
            login({
                openid_ns: searchParams.get('openid.ns'),
                openid_mode: searchParams.get('openid.mode'),
                openid_op_endpoint: searchParams.get('openid.op_endpoint'),
                openid_claimed_id: searchParams.get('openid.claimed_id'),
                openid_identity: searchParams.get('openid.identity'),
                openid_return_to: searchParams.get('openid.return_to'),
                openid_response_nonce: searchParams.get('openid.response_nonce'),
                openid_assoc_handle: searchParams.get('openid.assoc_handle'),
                openid_assoc_signed: searchParams.get('openid.signed'),
                openid_sig: searchParams.get('openid.sig'),
            });
        }
    }, [window.location.search]);

    async function loginSteamClick() {
        setLoggingIn(true);
        let result = await getAuthMetaDataApi();
        if (result.result) {
            const metaData=result.value as AuthMetaData;
            window.location.href = `https://steamcommunity.com/openid/login?openid.ns=http://specs.openid.net/auth/2.0&openid.mode=checkid_setup&openid.return_to=${metaData.redirectHostName}&openid.realm=${metaData.redirectHostName}&openid.ns.sreg=http://openid.net/extensions/sreg/1.1&openid.claimed_id=http://specs.openid.net/auth/2.0/identifier_select&openid.identity=http://specs.openid.net/auth/2.0/identifier_select`;
        }
        else {
            NotificationService.alertError(result.value)
        }
    }

    return (
        <Button
            variant="soft"
            color="neutral"
            fullWidth
            onClick={loginSteamClick}
            disabled={disabled}
        >
            Войти через Steam
        </Button>
    );
}
